<template>
  <!--  VISTA LISTAR-->
  <template v-if="view === 'listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
      :custom-create-actions="[listTipoPersona,listTipoDoc]" @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
      @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedPersona" :table-columns="tableColumns"
      :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
      :custom-update-selected-data="customUpdateSelectedData" :custom-update-actions="[listTipoPersona,listTipoDoc]"
      :custom-update-collection-data="customUpdateCollectionData" @updateValues="setupUpdateValues"
      :updatePermission="'updatePersona'"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate" :optionalParams="queries"
      @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedPersona" :load-data="loadDataPersona"
      :entity="entity" :auth-token="authToken" :list-api="listApi" :queries="queries" @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataPersona" :collectionTipoPersona="collectionTipoPersona"
        :collectionTipoDoc="collectionTipoDoc"
        :custom-update-value-data="customUpdateValueData" @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import { reactive, ref } from "vue";
import { useAuth } from "@/components/auth/store/composables";
import { copiaProfunda } from "@/common/constants";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import PersonasCrearActualizarComponent from "@/components/parametros/components/PersonasCrearActualizarComponent";
import { listCollectionData, useLayoutMain } from "@/layouts/main";

export default {
  name: 'PersonasCrud',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    PersonasCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Personas',
      entity: { gender: 'f', value: 'persona' },
      childHeaderComponent: 'childHeaderComponent',
      childFormComponent: 'PersonasCrearActualizarComponent',
      tableColumns: {
        "tipoDocumento.nombre_tipo_identificacion": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Tipo de Documento",
        },
        "identificacion": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "#. de Documento",
        },
        "primer_nombre": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Primer Nombre",
        },
        "segundo_nombre": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Segundo Nombre",
        },
        "primer_apellido": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Primer Apellido",
        },
        "segundo_apellido": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Segundo Apellido",
        },
        "tipoPersona.nombre": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Tipo de Persona",
        },
        "created_at": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: "Fecha de creación",
        },
      },
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionTipoPersona = ref([]);
    const collectionTipoDoc = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedPersona = ref({
      id: '',
      primer_nombre: '',
      segundo_nombre: '',
      primer_apellido: '',
      segundo_apellido: '',
      id_tipo_persona: '',
      identificacion: '',
      id_tipo_identificacion: '',
      estado: '',
    });
    const loadDataPersona = ref({
      primer_nombre: '',
      segundo_nombre: '',
      primer_apellido: '',
      segundo_apellido: '',
      id_tipo_persona: '',
      identificacion: '',
      id_tipo_identificacion: '',
    });

    const customUpdateValueData = (key, value) => {
      if (['identificacion', 'id_tipo_persona'].includes(key)) return value;
      return value;
    };
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_PERSONA_CREATE,
      list: process.env.VUE_APP_NEST_PERSONA_FINDALL,
      update: process.env.VUE_APP_NEST_PERSONA_UPDATE,
      updateState: process.env.VUE_APP_NEST_PERSONA_UPDATESTATE,
    });

    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedPersona.value)) {
        updatedSelectedData[key] = selectedCollectionData[key];
        if (key === 'tipoPersona') updatedSelectedData['tipoPersonaNombre'] = selectedCollectionData[key].id;
      }
      selectedPersona.value = updatedSelectedData;
    }
    const customUpdateCollectionData = () => {
      return copiaProfunda(collectionData.value);
    };
    const listTipoPersona = async () => await listCollectionData(process.env.VUE_APP_NEST_TIPO_PERSONA, { 'collectionTipoPersona': collectionTipoPersona }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)

    const listTipoDoc = async () => await listCollectionData(process.env.VUE_APP_NEST_TIPODOCUMENTO_FINDALL,  { 'collectionTipoDoc': collectionTipoDoc }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)

    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedPersona, loadDataPersona, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedPersona,
      loadDataPersona,
      listTipoPersona,
      listTipoDoc,
      listApi,
      paginate,
      queries,
      collectionTipoPersona,
      collectionTipoDoc,
      setupUpdateValues,
      cleanLoadSelectedData,
      customUpdateValueData,
      customUpdateCollectionData,
      customUpdateSelectedData
    };
  }
}
</script>